export default __webpack_public_path__ + "static/media/L40S.dd2405a5.png";